import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

export async function fetchMutualLikes(userId) {
  try {
    const response = await axiosInstance.get(Configs.mutualLikesEp, {
      params: { user_id: userId },
    });

    // Ensure consistent return structure
    return response.data.mutual_likes || [];
  } catch (error) {
    console.error("Error fetching mutual likes:", error);
    return [];
  }
}
